import {
    ChangeDetectionStrategy,
    Component,
    inject,
    output,
} from '@angular/core';
import { ArrayPipe, ButtonComponent } from '@interacta-shared/ui';
import { AIConvoAgentListItemComponent } from '@modules/ai-convo/components/ai-convo-agent-item/ai-convo-agent-list-item.component';
import { AIConvoHistoryListItemComponent } from '@modules/ai-convo/components/ai-convo-history-item/ai-convo-history-list-item.component';
import { AIConvoAgent } from '@modules/ai-convo/models/ai-convo-agent.model';
import { AIConvoHistoryItem } from '@modules/ai-convo/models/ai-convo-history.model';
import {
    selectAIConvoAgents,
    selectAIConvoAgentsFetching,
    selectAIConvoHistory,
} from '@modules/ai-convo/store/ai-convo.selectors';
import { AIDiscoveryService } from '@modules/ai-shared/services/ai-discovery.service';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-ai-convo-settings-panel',
    templateUrl: './ai-convo-settings-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        AIConvoAgentListItemComponent,
        AIConvoHistoryListItemComponent,
        ButtonComponent,
        TranslatePipe,
        ArrayPipe,
    ],
})
export class AIConvoSettingsPanelComponent {
    readonly newChat = output<void>();
    readonly showAllAgents = output<void>();
    readonly showAllHistory = output<void>();
    readonly agentSelected = output<AIConvoAgent>();
    readonly historyItemClick = output<AIConvoHistoryItem>();
    readonly historyItemRename = output<AIConvoHistoryItem>();
    readonly historyItemDelete = output<AIConvoHistoryItem>();

    private readonly store = inject(Store);
    private readonly aiDiscoveryService = inject(AIDiscoveryService);

    readonly agents = this.store.selectSignal(selectAIConvoAgents);
    readonly agentsFetching = this.store.selectSignal(
        selectAIConvoAgentsFetching,
    );
    readonly history = this.store.selectSignal(selectAIConvoHistory);

    openDiscoveryDialog(): void {
        this.aiDiscoveryService.openDialog('ai_panel_settings');
    }
}
